var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'line', params: { lin: '1-AGUA' }}}},[_c('div',{staticClass:"categories_menu"},[_c('div',{staticClass:"products_title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('Productos')))])])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }